import React from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { Icon } from "main/javascripts/components/icon/Icon";
import {
  fontSize,
  fontWeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  accentColor,
  backgroundColor,
} from "main/javascripts/styles/base/colorStyle";
import { useTranslation } from "react-i18next";
import { moreThanBreakpoint } from "../../../styles/base/responsiveStyle";

export const SearchFieldButtonSymbol: React.FC = (): React.ReactElement => {
  const { t } = useTranslation(["component"]);
  return (
    <div css={blockStyle}>
      <Icon styleKey="search" />
      <div>{t("post.bestPriceSearch")}</div>
    </div>
  );
};

const blockStyle = css`
  width: auto;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${space.atom0_5x};
  font-size: ${fontSize.caption};
  font-weight: ${fontWeight.bold};
  color: ${backgroundColor.primaryLightColor};
  background-color: ${accentColor.primaryColor};
  border-radius: 5px;
  padding: 0 ${space.atom};
  white-space: nowrap;
  i {
    color: ${backgroundColor.primaryLightColor};
    font-size: 1rem;
    margin-left: -0.125rem;
  }
  ${moreThanBreakpoint("tablet")} {
    padding: 0 ${space.atom2x};
  }
`;
